module.exports = __webpack_public_path__ + "static/img/新风主机.1b37a72e.png";